export const PACK_NAME_LIMIT = 20;
export const PACK_DESCRIPTION_LIMIT = 400;
export const KLYDO_NAME_LIMIT = 60;
export const USER_NAME_LIMIT = 20;
export const USER_DESCRIPTION_LIMIT = 400;
